import {useLayoutEffect, useRef, useState} from "react"

function getScrollElementFromTableRef(tableRef: {current: any} | null | undefined): HTMLElement | null {
    if (!tableRef?.current) {
        return null
    }
    const cur = tableRef.current
    if (typeof Element !== "undefined" && cur instanceof Element) {
        return cur as HTMLElement
    }
    const inner = cur._container
    if (typeof Element !== "undefined" && inner instanceof Element) {
        return inner as HTMLElement
    }
    return null
}

export const useSaveScroll = (tableRef) => {
    const savedScrollPosition = useRef(0)
    const [checkScrollPosition, setCheckScrollPosition] = useState(false)

    useLayoutEffect(() => {
        const el = getScrollElementFromTableRef(tableRef)
        if (el && savedScrollPosition.current !== 0) {
            el.scrollTop = savedScrollPosition.current
            savedScrollPosition.current = 0
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkScrollPosition])

    const handleActionRow = () => {
        const el = getScrollElementFromTableRef(tableRef)
        if (el) {
            savedScrollPosition.current = el.scrollTop
        }
        setCheckScrollPosition((prev) => !prev)
    }

    return {handleActionRow}
}
